import React, {useState, Suspense} from 'react'
import Session from '../session/Session'
import Loading from '../loading/Loading'

import vid1 from '../../assets/videos/1/1Vid.mp4'
import loop1 from '../../assets/videos/1/1Loop.mp4'

import vid2 from '../../assets/videos/2/2Vid.mp4'
import loop2 from '../../assets/videos/2/2Loop.mp4'

import vid3 from '../../assets/videos/3/3Vid.mp4'
import loop3 from '../../assets/videos/3/3Loop.mp4'


import vid4_1 from '../../assets/videos/4/4.1Vid.mp4'
import vid4_2 from '../../assets/videos/4/4.2Vid.mp4'
import loop4 from '../../assets/videos/4/4Loop.mp4'

import vid5_1 from '../../assets/videos/5/5.1Vid.mp4'
import vid5_2 from '../../assets/videos/5/5.2Vid.mp4'
import vid5_3 from '../../assets/videos/5/5.3Vid.mp4'
import vid5_4 from '../../assets/videos/5/5.4Vid.mp4'
import vid5_5 from '../../assets/videos/5/5.5Vid.mp4'
import loop5 from '../../assets/videos/5/5Loop.mp4'

import vid6 from '../../assets/videos/6/6Vid.mp4'
import loop6 from '../../assets/videos/6/6Loop.mp4'

import vid7_1 from '../../assets/videos/7/7.1Vid.mp4'
import vid7_2 from '../../assets/videos/7/7.2Vid.mp4'
import loop7 from '../../assets/videos/7/7Loop.mp4'

import vid8 from '../../assets/videos/8/8Vid.mp4'
import loop8 from '../../assets/videos/8/8Loop.mp4'
// const loopVideo1 = React.lazy(() => import('../../assets/videos/loop.mp4'));
// const talkingVideo1 = React.lazy(() => import('../../assets/videos/session1.mp4'));

const sessions = [
    {defaultTime:15 * 60 * 1000, title: 'Lobby',talkingVideo:vid1, loopVideo:loop1  },
    {defaultTime:15 * 60 * 1000, title: 'Introduction',talkingVideo:vid2, loopVideo:loop2  },
    {defaultTime:15 * 60 * 1000, title: 'Clear Your Mind',talkingVideo:vid3, loopVideo:loop3  },
    {defaultTime:15 * 60 * 1000, title: 'Setting Intentions',talkingVideo:vid4_1, loopVideo:loop4  },
    {defaultTime:15 * 60 * 1000, title: 'Setting Intentions',talkingVideo:vid4_2, loopVideo:loop4  },
    {defaultTime:15 * 60 * 1000, title: 'Finding The Way',talkingVideo:vid5_1, loopVideo:loop5  },
    {defaultTime:15 * 60 * 1000, title: 'Finding The Way',talkingVideo:vid5_2, loopVideo:loop5  },
    {defaultTime:15 * 60 * 1000, title: 'Finding The Way',talkingVideo:vid5_3, loopVideo:loop5  },
    {defaultTime:15 * 60 * 1000, title: 'Finding The Way',talkingVideo:vid5_4, loopVideo:loop5  },
    {defaultTime:15 * 60 * 1000, title: 'Finding The Way',talkingVideo:vid5_5, loopVideo:loop5  },
    {defaultTime:15 * 60 * 1000, title: 'Break',talkingVideo:vid6, loopVideo:loop6  },
    {defaultTime:15 * 60 * 1000, title: 'Lighting Questions ',talkingVideo:vid7_1, loopVideo:loop7  },
    {defaultTime:17 * 60 * 1000, title: 'Lighting Questions ',talkingVideo:vid7_2, loopVideo:loop7  },
    {defaultTime:15 * 60 * 1000, title: 'Digging Deeper',talkingVideo:vid8, loopVideo:loop8  },


]
export default function SessionsPage({nextPage}) {
    

    const [page, setPage] = useState(sessions[0])
    const [show , setShow] = useState(true)
    const nextSession = (add) =>  {
        if(add === 1 && sessions.indexOf(page) + 1 === sessions.length) {
            nextPage(1)
        }else {

            setPage(sessions[sessions.indexOf(page) + add ])
            setShow(false)
            setTimeout(() => {
                setShow(true)
            }, 10); 

        }

    } 
    const handleCancel = () => { 
        nextPage(-1)
    }

    return (
        <div> 
          {show?   <Session defaultTime={page.defaultTime} title={page.title} talkingVideo ={page.talkingVideo} loopVideo={page.loopVideo} nextPage={nextSession}  handleCancel ={handleCancel} end ={sessions.indexOf(page)+1 === sessions.length}/> :""}
{/* 
            {page === 'session1'? <Session defaultTime={15 * 60 * 1000} title={'Present'}  talkingVideo={talkingVideo1} loopVideo={loopVideo1}  nextSession={nextSession} /> : ""}
            {page === 'session2'? <Session defaultTime={15 * 60 * 1000} title={'Present'}  talkingVideo={talkingVideo1} loopVideo={loopVideo1}  nextSession={nextSession} /> : ""} */}

        </div>
    )
}
